
import axiosInstance from "./url.services";

export const sendOtp = async( phoneNumber, phoneSuffix, email )=>{
    try {
        
        const response = await axiosInstance.post('/auth/send-otp', {
            phoneNumber,
            phoneSuffix,
            email
        });
       
        console.log(response)
        return response.data;

    } catch (error) {
        throw error.response ? error.response.data : error.message;
        
    }

}

export const verifyOtp = async( phoneNumber, phoneSuffix, otp, email )=>{
    try {
        
        const response = await axiosInstance.post('/auth/verify-otp', {
            phoneNumber,
            phoneSuffix,
            otp,
            email
        });

        return response.data;

    } catch (error) {
        throw error.response ? error.response.data : error.message;
        
    }

}

export const updateUserProfile = async( updateData, config = {})=>{
    try {
        
        const response = await axiosInstance.put('/auth/update-profile', updateData,{
            
        ...config,          // ✅ onUploadProgress yahin se pass hoga
      

        });

        return response.data;

    } catch (error) {
        throw error.response ? error.response.data : error.message;
        
    }

}


export const checkUserAuth = async()=>{
    try {
        
        const response = await axiosInstance.get('/auth/check-auth');
     if( response.data.status === 'success'){
        return { isAuthenticated: true, user: response?.data?.data };
     }else if( response.data.status === 'error'){
        return { isAuthenticated: false, user: null };
     }
       

    } catch (error) {
        throw error.response ? error.response.data : error.message;
        
    }

}


export const logoutUser = async()=>{
    try {
        
        const response = await axiosInstance.get('/auth/logout');

        return response.data;

    } catch (error) {
        throw error.response ? error.response.data : error.message;
        
    }

}


export const getAllUsers = async()=>{
    try {
        
        const response = await axiosInstance.get('/auth/users');

        return response.data;

    } catch (error) {
        throw error.response ? error.response.data : error.message;
        
    }

}